import * as S from "./UserHealthInfo.style";
import HealthData from "@/common/types/healthData";
import { Buttons } from "@/components/atoms/Buttons";
import { AlertText } from "@/components/atoms/AlertText";
import { RadialChart } from "@/components/atoms/Charts/RadialChart";
import { ReactComponent as IconCamera } from "@/styles/assets/svg/icon_camera.svg";

interface HealthMetrics {
  bmi?: number;
  spineAngle?: number;
  bodyFatPercentage?: number;
}

interface UserHealthInfoProps {
  title?: string;
  photoData?: boolean;
  healthData?: boolean;
  studentData?: boolean;
  statusLevels?: HealthData;
  onCameraClick?: () => void;
  handleHealthInfoClick?: () => void;
  healthMetrics?: HealthMetrics;
}

export const UserHealthInfo = ({
  title,
  photoData = false,
  healthData = false,
  studentData,
  statusLevels,
  onCameraClick,
  handleHealthInfoClick,
  healthMetrics = {},
}: UserHealthInfoProps) => {
  const { spineAngle = 0, bmi = 0, bodyFatPercentage = 0 } = healthMetrics;

  return (
    <S.UserHealthInfo
      $healthData={healthData}
      $photoData={photoData}
      $studentData={studentData}
    >
      <S.UserHealthTit>
        {title === "student"
          ? "내 건강 요약"
          : title === "guardian" && studentData
            ? "학생 건강 요약"
            : ""}
      </S.UserHealthTit>

      <S.UserHealthData
        $healthData={healthData}
        $photoData={photoData}
        $studentData={studentData}
      >
        {studentData ? (
          !photoData && !healthData ? (
            <AlertText
              mainText="수집된 건강 정보가 없습니다."
              subText={
                <>
                  척추 사진 등록 및 건강 정보 입력을 해주세요. <br />
                  *사진 등록 및 건강 정보 입력을 하지 않아도 <br />
                  어플 사용은 가능합니다.
                </>
              }
              button={
                <>
                  <Buttons
                    type="button"
                    size="responsive"
                    layout="outline"
                    color="primary100"
                    icon={<IconCamera width={24} height={24} />}
                    label="척추 사진 등록하기"
                    onClick={onCameraClick}
                  />
                  <Buttons
                    type="button"
                    size="responsive"
                    layout="outline"
                    color="primary100"
                    label="건강 정보 입력하기"
                    onClick={handleHealthInfoClick}
                  />
                </>
              }
            />
          ) : (
            <S.UserHealthChartBox>
              <RadialChart
                title="척추측만확률"
                color="yellow"
                data={{
                  minValue: 0,
                  maxValue: 100,
                  value: spineAngle,
                  unit: "%",
                }}
              />
              <RadialChart
                title="BMI"
                color="green"
                status={
                  statusLevels?.data?.bmi ? statusLevels?.data?.bmi.status : "0"
                }
                data={{
                  minValue: 0,
                  maxValue: 30,
                  value: bmi,
                  unit: "kg/m²",
                }}
              />
              <RadialChart
                title="체지방률"
                color="red"
                status={
                  statusLevels?.data?.bodyFatPercentage
                    ? statusLevels?.data?.bodyFatPercentage.status
                    : "0"
                }
                data={{
                  minValue: 0,
                  maxValue: 40,
                  value: bodyFatPercentage,
                  unit: "%",
                }}
              />
            </S.UserHealthChartBox>
          )
        ) : (
          <AlertText
            mainText="연결된 학생 정보가 없습니다."
            subText="학생 계정에서 법정보호자 연결을 진행해주세요."
          />
        )}
      </S.UserHealthData>
    </S.UserHealthInfo>
  );
};
